import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "submit", "rejectFields"]
  static values = { rejectPath: String }

  connect() {
    this.toggleSubmit()
    this.toggleRejectFields()
  }

  updateAction() {
    this.element.action = this.selectTarget.value
    this.toggleSubmit()
    this.toggleRejectFields()
  }

  toggleSubmit() {
    this.submitTarget.disabled = !this.selectTarget.value
  }

  // The optional "why is this a false positive?" box is only relevant when the
  // reviewer is rejecting. Reveal it for the reject option, hide it otherwise.
  toggleRejectFields() {
    if (!this.hasRejectFieldsTarget) return
    const isReject = this.rejectPathValue && this.selectTarget.value === this.rejectPathValue
    this.rejectFieldsTarget.classList.toggle("hidden", !isReject)
  }
}
